import * as React from "react";
// Styles
import styles from "./index.module.scss";

interface IProps {
	counter?: number;
	onFinished: () => void;
}
const Counter: React.FC<IProps> = (props: IProps) => {
	const counterIntervalId = React.useRef<any>();
	const [count, setCount] = React.useState<number>(() => props.counter || 5);
	const [running, setRunning] = React.useState<boolean>(false);

	// Fire on mounted component
	React.useEffect(() => {
		!running && handleCountdown();

		return () => {
			handleStop();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// Fire when counter variable has changed
	React.useEffect(() => {
		if (count <= 0) {
			handleStop();

			props.onFinished();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [count]);

	// Start counter down
	function handleStart(): void {
		counterIntervalId.current = setInterval(() => {
			setCount(currentCount => {
				const newCount = currentCount - 1;

				return newCount >= 0 ? newCount : 0;
			});
		}, 1000);
	}

	// Stop counte down
	function handleStop() {
		if (counterIntervalId.current) {
			clearInterval(counterIntervalId.current);
			setRunning(false);

			counterIntervalId.current = null;
		}
	}

	// Run counter down
	function handleCountdown() {
		handleStart();
		setRunning(true);
	}

	// Format a number to a valid clock format
	function format(counter: number): string {
		let seconds: string | number = counter % 60;
		let minutes: string | number = Math.floor(counter / 60);

		minutes = minutes < 10 ? "0" + minutes : minutes;
		seconds = seconds < 10 ? "0" + seconds : seconds;

		return `${minutes}:${seconds}`;
	}

	return (
		<div className={styles["counter"]}>
			جهت ارسال مجدد کد پیامکی
			<span className={styles["counter__timer"]}>{format(count)}</span>
			صبر کنید
		</div>
	);
};

export default React.memo(Counter);
